module.exports = __webpack_public_path__ + "img/1504639321.8be2dce4.jpg";